import PropTypes from "prop-types";
import React from "react";

/**
 *  A checkbox control that sends in the correct attributes to Rails
 *  Also allows for the indeterminate attribute to be set.
 *
 * @example <CheckBox value={true} id="hook_active" name="hook[active]" indeterminate={true} />
 */
class CheckBox extends React.Component {
  /**
   * Sets the default state
   *
   * @param {object} props The props passed in
   */
  constructor(props) {
    super(props);
    this.el = React.createRef();
    this.state = {
      checked: props.checked === undefined ? props.defaultValue : props.checked,
      indeterminate: props.checked === undefined
    };
    this.onChange = this.onChange.bind(this);
  }

  /**
   * Sets the indeterminate prop of the element
   */
  componentDidMount() {
    this.el.current.indeterminate = this.state.indeterminate;
  }

  /**
   * Sets the name of the hidden input depending on indeterminate
   *
   * @returns {string} The name of the control or nothing to prevent submitting
   */
  name() {
    return this.state.indeterminate ? "" : this.props.name;
  }

  /**
   * Resets the checked state if the checkbox is changed
   *
   * @param {object} event The event object
   */
  onChange(event) {
    const newState = {};
    if (this.state.indeterminate) {
      newState.indeterminate = false;
      newState.checked = this.props.defaultValue;
    } else {
      newState.checked = event.target.checked;
    }

    this.setState(newState);
  }

  /**
   * Renders the component
   *
   * @returns {object} The ReactComponent
   */
  render() {
    const inputProps = { ...this.props };
    delete inputProps.name;
    delete inputProps.indeterminate;
    delete inputProps.defaultValue;
    delete inputProps.checked;

    return (
      <React.Fragment>
        <input name={this.name()} type="hidden" value="0" />
        <input
          checked={this.state.checked}
          name={this.name()}
          onChange={this.onChange}
          ref={this.el}
          type="checkbox"
          value="1"
          {...inputProps}
        />
      </React.Fragment>
    );
  }
}

CheckBox.propTypes = {
  checked: PropTypes.bool,
  defaultValue: PropTypes.bool,
  name: PropTypes.string.isRequired
};

export default CheckBox;
